import { WifiOff, AlertTriangle } from "lucide-react";
import { useOffline } from "../lib/offline";

function fmtDateTime(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}, ${p(d.getHours())}:${p(d.getMinutes())}`;
}

function fmtDate(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}

// 22 Sep 2026 · Zwei Zustände:
//  · Daten älter als 7 Tage → auffällige rote Warnung (auch online, bis der
//    nächste Sync greift).
//  · Offline & Daten frisch → dezenter Navy/Gold-Hinweis mit Zeitstempel.
export default function OfflineBanner() {
  const { online, lastSync, isStale } = useOffline();

  if (isStale) {
    return (
      <div
        data-testid="stale-warning"
        className="sticky top-[var(--wb-header-h,96px)] z-30 flex items-center justify-center gap-2 px-4 py-2 text-[12px] md:text-[13px] font-semibold text-white text-center"
        style={{ background: "#B42318" }}
      >
        <AlertTriangle className="w-4 h-4 shrink-0" strokeWidth={2} />
        <span>
          Diese Daten sind älter als 7 Tage (Stand: {fmtDate(lastSync)}). Bitte verbinden Sie sich
          mit dem Internet, um aktuelle Angaben zu sehen.
        </span>
      </div>
    );
  }

  if (!online) {
    return (
      <div
        data-testid="offline-banner"
        className="sticky top-[var(--wb-header-h,96px)] z-30 flex items-center justify-center gap-2 px-4 py-1.5 text-[11px] md:text-[12px] tracking-[0.1em] text-center"
        style={{ background: "#0F1E3D", color: "#C9A961" }}
      >
        <WifiOff className="w-3.5 h-3.5 shrink-0" strokeWidth={1.8} />
        <span>{lastSync ? `Offline – Stand: ${fmtDateTime(lastSync)}` : "Offline"}</span>
      </div>
    );
  }

  return null;
}
